import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import VueCookies from 'vue-cookies'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta:{
      needLogin:false
    }
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ '../views/dashboard/index.vue'),
    redirect:"/home",
    meta: { title: '首页' },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home
      },{
        path: '/client',
        name: 'Client',
        component: () => import('@/views/Client/index.vue')
      },{
        path: '/goods',
        name: 'Goods',
        component: () => import('@/views/Goods/index.vue')
      },{
        path: '/order',
        name: 'Order',
        component: () => import('@/views/Order/index.vue'),
        meta: {
          keepAlive: true,  // 需要被缓存
        },
      },{
        path: '/setting',
        name: 'Setting',
        component: () => import('@/views/Setting/index.vue')
      },{
        path: '/addGoods',
        name: 'AddGoods',
        component: () => import('@/views/AddGoods/index.vue')
      },{
        path: '/goodsSerieslist',
        name: 'GoodsSerieslist',
        component: () => import('@/views/GoodsSerieslist/index.vue')
      },{
        path: '/freightList',
        name: 'FreightList',
        component: () => import('@/views/FreightList/index.vue')
      },{
        path: '/stores',
        name: 'Stores',
        component: () => import('@/views/Stores/index.vue'),
      },{
        path: '/logistics',
        name: 'Logistics',
        component: () => import('@/views/Logistics/index.vue')
      },{
        path: '/sku',
        name: 'Sku',
        component: () => import('@/views/Sku/index.vue')
      },{
        path: '/shopify/redirect',
        name: 'Redirect',
        component: () => import('@/views/Redirect/index.vue')
      },{
        path: '/paymentSet',
        name: 'PaymentSet',
        component: () => import('@/views/PaymentSet/index.vue')
      },{
        path: '/logisticsSet',
        name: 'LogisticsSet',
        component: () => import('@/views/LogisticsSet/index.vue')
      },{
        path: '/comment',
        name: 'Comment',
        component: () => import('@/views/Comment/index.vue')
      },{
        path: '/discount',
        name: 'Discount',
        component: () => import('@/views/Discount/index.vue'),
        children:[
          {
            path:"/discount/add",
            name:"DiscountAdd",
            component:() => import('@/views/Discount/components/add.vue')
          },{
            path:"/discount/edit",
            name:"DiscountEdit",
            component:() => import('@/views/Discount/components/edit.vue')
          }
        ]
      },{
        path: '/addUser',
        name: 'AddUser',
        component: () => import('@/views/AddUser/index.vue')
      },{
        path: '/FBaccount',
        name: 'FBaccount',
        component: () => import('@/views/FBaccount/index.vue'),
        children:[
          {
            path:"/FBaccount/add",
            name:"FBaccountAdd",
            component:() => import('@/views/FBaccount/components/add.vue')
          }
        ]
      },{
        path: '/shopifyOrder',
        name: 'ShopifyOrder',
        component: () => import('@/views/ShopifyOrder/index.vue'),
        meta: {
          keepAlive: true,  // 需要被缓存
        },
      },{
        path: '/shopifyStores',
        name: 'ShopifyStores',
        component: () => import('@/views/ShopifyStores/index.vue')
      },{
        path: '/OperationalData',
        name: 'OperationalData',
        component: () => import('@/views/OperationalData/index.vue')
      },{
        path: '/pitching',
        name: 'pitching',
        component: () => import('@/views/OperationalData/pitching.vue')
      }
      ,{
        path: '/roleManager',
        name: 'roleManager',
        component: () => import('@/views/RoleManager/index.vue')
      },{
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/OrderDetail/index.vue')
      },{
        path: '/advNumber',
        name: 'advNumber',
        component: () => import('@/views/AdvNumber/index.vue')
      },{
        path: '/advNumberDetail',
        name: 'advNumberDetail',
        component: () => import('@/views/AdvNumber/detail.vue')
      },
      {
        path: '/wuliu',
        name: 'wuliu',
        component: () => import('@/views/wuliu/index.vue')
      },
      {
        path: '/dispute',
        name: 'dispute',
        component: () => import('@/views/dispute/index.vue')
      },
      {
        path: '/disputeDetail',
        name: 'disputeDetail',
        component: () => import('@/views/dispute/detail.vue')
      },
      {
        path: '/see',
        name: 'see',
        component: () => import('@/views/see/see.vue')
      },
      {
        path: '/logisticsAcc',
        name: 'logisticsAcc',
        component: () => import('@/views/logisticsAcc/index.vue')
      },
      {
        path: '/GetTokenOfChuKou1',
        name: 'GetToken',
        component: () => import('@/views/GetToken/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 登录鉴权
router.beforeEach((to, from, next) => {
  /* 
  如果是登录 一定不要判断
  */
  if (to.fullPath === "/login") {
    next();
  } else {
    const token = VueCookies.get('token')
      if (token) {
        next();
      } else {
        next("/login");
      }
  }
})

export default router
